'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import { faEllipsis as N } from "../../external/@fortawesome/pro-solid-svg-icons/index.js";
import { FontAwesomeIcon as h } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { useCallback as v, Fragment as T } from "react";
import { formatDate as u, formatTime as C } from "../../helpers/dateUtils.js";
import n from "../../external/classnames/index.js";
import { useTheme as S } from "../Provider/index.js";
import { imageContentTypes as p, chatThumbnailStyleBySupportType as g, defaultChatThumbnailStyle as k, chatThumbnailIconBySupportType as E, defaultChatThumbnailIcon as D } from "./ChatContainer.js";
import j from "./MessageBody.js";
const q = ({
  supportType: s,
  messages: l,
  identity: i,
  hasMoreMessages: y = !1,
  onOpenImage: c,
  onOpenFile: m,
  isClosed: b
}) => {
  const { isMosh: o, isMoshy: x } = S(), w = v(
    (t, a) => {
      const r = u(t);
      return a === l.length - 1 || r !== u(new Date(l[a + 1].timeStamp)) ? /* @__PURE__ */ e.jsx("small", { className: "w-full text-center font-bolder text-grey-400", children: `${r}, ${C(t)}` }) : null;
    },
    [l]
  );
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col-reverse flex-1 items-end gap-4", children: [
    l.map((t, a) => {
      var r, d, f;
      return /* @__PURE__ */ e.jsxs(T, { children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            "data-testid": "message",
            className: n(
              "flex flex-row gap-4 items-end text-grey-400",
              {
                "self-start": t.contentCreator !== i,
                "max-w-[calc(100%_-_4rem)]": !(t.attachmentExtension && p.includes(
                  t.attachmentExtension
                )),
                "w-[16rem] max-w-[50%]": t.attachmentExtension && p.includes(
                  t.attachmentExtension
                )
              }
            ),
            "data-is-outbound": t.contentCreator === i,
            children: t.contentCreator !== i ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: n(
                    "flex items-center justify-center rounded-full p-4",
                    b ? "bg-grey-300 text-white" : ((d = (r = g) == null ? void 0 : r[s]) == null ? void 0 : d[o ? "mosh" : "moshy"]) || k
                  ),
                  children: /* @__PURE__ */ e.jsx(
                    h,
                    {
                      icon: ((f = E) == null ? void 0 : f[s]) || D,
                      className: "!h-4 w-4"
                    }
                  )
                }
              ),
              /* @__PURE__ */ e.jsxs("div", { className: "flex flex-1 flex-col gap-2 items-start justify-center", children: [
                /* @__PURE__ */ e.jsx("small", { children: t.displayName || "" }),
                /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    className: n(
                      "p-3 rounded-2xl rounded-bl bg-grey-100 break-anywhere",
                      {
                        "text-green-dark": o,
                        "text-black": x
                      }
                    ),
                    children: /* @__PURE__ */ e.jsx(
                      j,
                      {
                        message: t,
                        onOpenFile: m,
                        onOpenImage: c
                      }
                    )
                  }
                )
              ] })
            ] }) : /* @__PURE__ */ e.jsx("div", { className: "flex flex-1 flex-col gap-2 items-start justify-center", children: /* @__PURE__ */ e.jsx(
              "div",
              {
                className: n(
                  "p-3 rounded-2xl rounded-br text-white break-anywhere",
                  {
                    "!bg-green-faint-dark": o,
                    "!bg-blue": x
                  }
                ),
                children: /* @__PURE__ */ e.jsx(
                  j,
                  {
                    message: t,
                    onOpenFile: m,
                    onOpenImage: c
                  }
                )
              }
            ) })
          }
        ),
        t.timeStamp ? w(new Date(t.timeStamp), a) : null
      ] }, t.id);
    }),
    y ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-row items-center justify-center w-full text-grey-200", children: /* @__PURE__ */ e.jsx(h, { icon: N }) }) : null
  ] });
};
export {
  q as default
};
